import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { cn } from "@/utils/styleHelper";
export const Link = /*#__PURE__*/ React.forwardRef(function Link({ href, external = false, underline = true, className, children, ...props }, ref) {
    const defaultStyles = cn('text-navy hover:text-navy-90 font-medium transition-colors', underline && 'underline underline-offset-2', className);
    // For external links, use regular anchor tag
    if (external || href.startsWith('http://') || href.startsWith('https://')) {
        return /*#__PURE__*/ _jsx("a", {
            href: href,
            ref: ref,
            className: defaultStyles,
            target: "_blank",
            rel: "noreferrer",
            ...props,
            children: children
        });
    }
    // For internal links, use React Router
    return /*#__PURE__*/ _jsx(RouterLink, {
        to: href,
        ref: ref,
        className: defaultStyles,
        ...props,
        children: children
    });
});
